import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const RedoIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "RedoIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M10.5,6a.5.5,0,0,1-.09-.992L10.5,5h3.82A7,7,0,1,0,8,15a.5.5,0,1,1,0,1A8,8,0,1,1,15,4.132V.5a.5.5,0,0,1,.41-.492L15.5,0a.5.5,0,0,1,.492.41L16,.5v5a.5.5,0,0,1-.41.492L15.5,6Z" }) })));
RedoIcon.displayName = "RedoIcon";
